import {EntityWithId} from "../baseEntities";

export enum SolicitationFinancePreferencesFields {
    SolicitationId = 'idSolicitud',
    BankCode = 'codBanco',
    CommercialCode = 'idComercial',
    Amount = 'monto',
    Guarantee = 'garantia',
    Term = 'plazo',
    RateTypeCode = 'codTasaModo',
    Rate = 'tasa',
    AmortizationSystemCode = 'codSistemaAmortizacion',
    GraceMonths = 'mesesGracia',
    PeriodicityCode = 'codPeriodicidad',
    DestinationReasonCode = 'codOperacionDestinoMotivo',
    Line = 'descLinea',
    EligibilityCode = 'codigoDeElegibilidad',
    Comments = 'comentario'
}

export interface SolicitationFinancePreferences extends EntityWithId<number> {
    [SolicitationFinancePreferencesFields.SolicitationId]: number,
    [SolicitationFinancePreferencesFields.BankCode]: number,
    [SolicitationFinancePreferencesFields.CommercialCode]: number,
    [SolicitationFinancePreferencesFields.Amount]: number,
    [SolicitationFinancePreferencesFields.Guarantee]: number,
    [SolicitationFinancePreferencesFields.Term]: number,
    [SolicitationFinancePreferencesFields.RateTypeCode]: number,
    [SolicitationFinancePreferencesFields.Rate]: number,
    [SolicitationFinancePreferencesFields.AmortizationSystemCode]: number,
    [SolicitationFinancePreferencesFields.GraceMonths]: number,
    [SolicitationFinancePreferencesFields.PeriodicityCode]: number,
    [SolicitationFinancePreferencesFields.DestinationReasonCode]: number,
    [SolicitationFinancePreferencesFields.Line]: string,
    [SolicitationFinancePreferencesFields.EligibilityCode]: string,
    [SolicitationFinancePreferencesFields.Comments]: string
}

export interface SolicitationFinancePreferencesForm {
    [SolicitationFinancePreferencesFields.SolicitationId]?: number,
    [SolicitationFinancePreferencesFields.BankCode]?: number,
    [SolicitationFinancePreferencesFields.CommercialCode]?: number,
    [SolicitationFinancePreferencesFields.Amount]?: number,
    [SolicitationFinancePreferencesFields.Guarantee]?: number,
    [SolicitationFinancePreferencesFields.Term]?: number,
    [SolicitationFinancePreferencesFields.RateTypeCode]?: number,
    [SolicitationFinancePreferencesFields.Rate]?: number,
    [SolicitationFinancePreferencesFields.AmortizationSystemCode]?: number,
    [SolicitationFinancePreferencesFields.GraceMonths]?: number,
    [SolicitationFinancePreferencesFields.PeriodicityCode]?: number,
    [SolicitationFinancePreferencesFields.DestinationReasonCode]?: number,
    [SolicitationFinancePreferencesFields.Line]?: string,
    [SolicitationFinancePreferencesFields.EligibilityCode]?: string,
    [SolicitationFinancePreferencesFields.Comments]?: string
}